@if (showGlobalSpinner) {
<div>
  <div class="loading">
    <mat-spinner></mat-spinner>
  </div>
</div>
}
<div>
  <div>
    <div class="class-roster-body">
      <div class="class-roster-title">
        <h1>Program Documents</h1>
      </div>
    </div>
  </div>
  <div class="panel">
    <div class="panel-header panel-header-2">
      <div class="panel-title">
        <span class="p-t-0 p-b-0">
          <img src="assets/icons/document-icon-blue.svg" alt="">
        </span>
        <p>Documents ( {{ programDocs?.length }} )</p><br />
      </div>
      <div class="displayFlex">
        <div class="class-roster-body">
          <div class="class-roster-title add-doc-icon">
            <div class="export-button" (click)="addRow()">
              Add Document
              <img src="assets/icons/document-icon-white.svg" alt="" ml10>
            </div>
          </div>
        </div>
      </div>
    </div>
    @if (programDocs?.length) {
    <p class="p-select-mobile-msg">
      By selecting 'display on mobile' you are confirming stakeholder approval to display the document.
    </p>
    }
    @if (isFilterRes) {
    <p class="no-results-filter">{{ filterRes }}</p>
    } @else {
    @if (programDocs) {
    <form class="panel-body" [formGroup]="eventsTable">
      <div class="events-table">
        @if (eventsTable?.get('tableRows')?.controls?.length) {
        <table class="table participant-table">
          <thead #target class="sticky">
            <!-- FIX: thead must contain a tr -->
            <tr>
              <th class="col-name">
                <span>DOCUMENT NAME</span>
                <img (click)="sort('name')" [ngClass]="{'active':isNameAsc}" src="assets/icons/sort-by-down.svg" alt="">
              </th>
              <th class="col-desc">
                <span>DESCRIPTION</span>
                <img (click)="sort('desc')" [ngClass]="{'active':isDescriptionAsc}" src="assets/icons/sort-by-down.svg"
                  alt="">
              </th>
              <th class="col-url">
                <span>DOCUMENT URL</span>
                <img (click)="sort('url')" [ngClass]="{'active':isTypeAsc}" src="assets/icons/sort-by-down.svg" alt="">
              </th>
              <th class="col-mobile">
                <span>DISPLAY ON MOBILE</span>
                <img (click)="sort('mobileDisplay')" [ngClass]="{'active':isRegisteredAsc}"
                  src="assets/icons/sort-by-down.svg" alt="">
              </th>
              <th class="col-actions">
                <span>ACTIONS</span>
              </th>
            </tr>
          </thead>
          <tbody>
            @for (group of getFormControls.controls; track group; let i = $index) {
            <ng-container formArrayName="tableRows">
              @if (group.get('isEditable').value) {
              <tr [formGroupName]="i">
                <td class="col-name">
                  <mat-form-field>
                    <mat-label>Document Name</mat-label>
                    <input matInput type="text" formControlName="name" maxlength="50">
                  </mat-form-field>
                  <span class="textGreySmall">
                    {{ group.get('name')?.value ? group.get('name')?.value?.length : 0 }} / 50
                  </span>
                </td>
                <td class="col-desc">
                  <mat-form-field>
                    <mat-label>Description</mat-label>
                    <input matInput type="text" formControlName="desc" maxlength="300">
                  </mat-form-field>
                  <span class="textGreySmall">
                    {{ group.get('desc')?.value ? group.get('desc')?.value?.length : 0 }} / 300
                  </span>
                </td>
                <td class="col-url">
                  <mat-form-field>
                    <mat-label>Document URL</mat-label>
                    <input matInput type="text" formControlName="url">
                  </mat-form-field>
                  <!-- spacer line to match name/desc counters -->
                  <span class="textGreySmall textGreySmall--spacer">&nbsp;</span>
                </td>
                <td class="col-mobile">
                  <!-- keep formControlName, but center + make checkbox visible via CSS -->
                  <div class="mobile-cell">
                    <mat-checkbox formControlName="mobileDisplay"></mat-checkbox>
                    <!-- spacer line to match name/desc counters -->
                    <span class="textGreySmall textGreySmall--spacer">&nbsp;</span>
                  </div>
                </td>
                <td class="col-actions actions-cell">
                  <button matTooltip="Cancel" matTooltipPosition="above" mat-icon-button color="warn"
                    (click)="cancelRow(i, group)">
                    <mat-icon>close</mat-icon>
                  </button>
                  <button matTooltip="Save" matTooltipPosition="above" mat-icon-button class="text-green"
                    [disabled]="!eventsTable.valid" (click)="saveRow(group)">
                    <mat-icon>done</mat-icon>
                  </button>
                </td>
              </tr>
              }
              @if (!group.get('isEditable').value) {
              <tr>
                <td class="col-name">
                  <div class="user-profile">
                    <div>
                      <span class="table-name-head seeParticipants">
                        {{ group.get('name').value }}
                      </span>
                    </div>
                  </div>
                </td>
                <td class="col-desc tb-date-desc">
                  {{ group.get('readMore').value ? group.get('desc').value :
                  (group.get('desc').value | slice:0:50) }}
                  @if (group.get('desc').value.length > '50') {
                  <a class="seeMore" (click)="group.get('readMore').value = !group.get('readMore').value">
                    {{ group.get('readMore').value ? 'See Less' : 'See More' }}
                  </a>
                  }
                </td>
                <td class="col-url">
                  <a class="restrict-url" href="{{ group.get('url').value }}" target="_blank">
                    {{ group.get('url').value }}
                  </a>
                </td>
                <td class="col-mobile">
                  <div class="mobile-cell">
                    <input class="td-mobile-display" type="checkbox" [checked]="group.get('mobileDisplay').value"
                      disabled>
                  </div>
                </td>
                <td class="col-actions actions-cell">
                  <button matTooltip="Edit" matTooltipPosition="above" mat-icon-button color="primary"
                    (click)="editRow(group, addRowExist)" [disabled]="disableDeleteEditButons[i]">
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button matTooltip="Delete" matTooltipPosition="above" mat-icon-button color="warn"
                    (click)="deleteRow(i, group)" [disabled]="disableDeleteEditButons[i]">
                    <mat-icon>delete</mat-icon>
                  </button>
                </td>
              </tr>
              }
            </ng-container>
            }
          </tbody>
        </table>
        } @else {
        <p class="background-white m-t-xs">
          <span class="m-l-lg">
            <error-message [errorMessage]="errorMessage"></error-message>
          </span>
        </p>
        }
      </div>
    </form>
    } @else {
    @if (!showLoading) {
    <div class="loading">
      <mat-spinner></mat-spinner>
    </div>
    }
    }
    }
  </div>
</div>